import list from "@/pages/mission/list";
import view from "@/pages/mission/view";
import customerInfo from "@/pages/mission/customerInfo";
import deliverList from "@/pages/deliverMission/list"
import mapView from "../pages/deliverMission/mapView";
import missionItemInfo from "../pages/deliverMission/missionItemInfo";
import missionInfo from "../pages/deliverMission/missionInfo";
import collectAllItems from "../pages/deliverMission/collectAllItems";
import paymentList from "../pages/paymentMission/list";
import mDetail from "../pages/paymentMission/mDetail";
import mItemDetail from "../pages/paymentMission/mItemDetail";


const routes = [
  {
    path: "/Mission/Manage",
    component: list,
    meta: {requiredAuth: true},
  },
  {
    path: "/Mission/View/:id",
    component: view,
    meta: {requiredAuth: true},
  },
  {
    path: "/Mission/customerInfo/:id",
    component: customerInfo,
    meta: {requiredAuth: true},
  },
  {
    path: "/DeliverMission/Manage",
    component: deliverList,
    meta: {requiredAuth: true},
  },
  {
    path: "/DeliverMission/MapView/:id",
    component: mapView,
    meta: {requiredAuth: true},
  },
  {
    path: "/DeliverMission/itemId/:id",
    component: mapView,
    meta: {requiredAuth: true},
  },
  {
    path: "/DeliverMissions/itemId/:id",
    component: missionItemInfo,
    meta: {requiredAuth: true},
  },
  {
    path: "/DeliverMissions/Info/:id",
    component: missionInfo,
    meta: {requiredAuth: true},
  },
  {
    path: "/deliverMissionAllItems/:id",
    component: collectAllItems,
    meta: {requiredAuth: true},
  },
  {
    path: "/PaymentMission/Manage",
    component: paymentList,
    meta: {requiredAuth: true},
  },
  {
    path: "/PaymentMission/View/:id",
    component: mDetail,
    meta: {requiredAuth: true},
  },
  {
    path: "/paymentMission/ItemView/:id",
    component: mItemDetail,
    meta: {requiredAuth: true},
  },
]

export default routes